export { PrivacyPage as default } from '@/components/enpages/Legal/Privacy'
